import React from 'react'
import SvgIcon from 'rambler-ui/icons/SvgIcon'

export default function LetidorLogo ({width, height}) {
  return (
    <SvgIcon
      color='currentColor'
      style={{
        width: width,
        height: height
      }}
      viewBox='0 0 119 50'>
      <g fill='none' fillRule='evenodd'>
        <g fillRule='nonzero'>
          <path
            fill='#0093E5'
            d='M83.256 31.81c-.871 0-1.52-.186-1.966-.575a2.044 2.044 0 0 1-.667-1.633v-2.021c0-.705.222-1.262.667-1.651.445-.39 1.113-.575 1.966-.575.854 0 1.521.185 1.967.575.445.39.667.946.667 1.65v2.022c0 .705-.222 1.243-.667 1.633-.446.37-1.113.575-1.967.575zm0-1.039c.464 0 .817-.093 1.002-.297.204-.185.297-.52.297-.983v-1.8c0-.481-.093-.815-.297-1.02-.204-.203-.538-.296-1.002-.296-.463 0-.816.093-1.001.297-.204.204-.297.538-.297 1.02v1.8c0 .463.093.797.297.982.185.186.52.297 1.001.297z'
          />
          <path
            fill='#964DC2'
            d='M19.45 30.678h.946v-4.21h-.946v-1.039h3.45v1.039h-1.169v4.229h2.078v-1.484h1.28v2.522H19.45z'
          />
          <path
            fill='#964DC2'
            d='M26.35 34.685h-8.161a2.033 2.033 0 0 1-2.04-2.04v-8.162c0-1.131.908-2.04 2.04-2.04h8.161c1.131 0 2.04.909 2.04 2.04v8.161c0 1.132-.909 2.04-2.04 2.04zm-8.161-11.13a.918.918 0 0 0-.928.928v8.161c0 .52.408.928.928.928h8.161c.52 0 .927-.408.927-.928v-8.16a.918.918 0 0 0-.927-.928h-8.161z'
          />
          <path
            fill='#B4D534'
            d='M46.494 31.717v-1.039h1.112v-4.21H46.42v1.205h-1.335V25.43h6.38v2.244H50.13v-1.205h-1.187v4.229h1.113v1.038h-3.561z'
          />
          <path
            fill='#B4D534'
            d='M52.355 34.685h-8.161a2.033 2.033 0 0 1-2.04-2.04v-8.162c0-1.131.908-2.04 2.04-2.04h8.16c1.132 0 2.041.909 2.041 2.04v8.161c0 1.132-.909 2.04-2.04 2.04zm-8.161-11.13a.918.918 0 0 0-.928.928v8.161c0 .52.408.928.928.928h8.16c.52 0 .928-.408.928-.928v-8.16a.918.918 0 0 0-.927-.928h-8.161zM96.352 31.717h-3.08v-1.039h.947v-4.21h-.946v-1.039h4.025c.667 0 1.168.148 1.502.445.334.297.52.724.52 1.299v.426c0 .445-.112.816-.316 1.095a1.632 1.632 0 0 1-.927.575l.76 1.428h1.002v1.038h-1.855l-1.299-2.374h-1.112v1.336h.779v1.02zm-.78-3.413h1.466c.352 0 .612-.056.742-.167.148-.111.204-.297.204-.556v-.371c0-.279-.074-.464-.204-.575-.149-.112-.39-.167-.742-.167h-1.465v1.836z'
          />
          <path
            fill='#B4D534'
            d='M100.655 34.685h-8.161a2.033 2.033 0 0 1-2.04-2.04v-8.162c0-1.131.908-2.04 2.04-2.04h8.16c1.132 0 2.041.909 2.041 2.04v8.161c0 1.132-.909 2.04-2.04 2.04zm-8.161-11.13a.918.918 0 0 0-.928.928v8.161c0 .52.408.928.928.928h8.16c.52 0 .928-.408.928-.928v-8.16a.918.918 0 0 0-.927-.928h-8.161z'
          />
          <path
            fill='#FF3D4B'
            d='M65.728 34.685h-8.161a2.033 2.033 0 0 1-2.04-2.04v-8.162c0-1.131.908-2.04 2.04-2.04h8.161c1.132 0 2.04.909 2.04 2.04v8.161c0 1.132-.908 2.04-2.04 2.04zm-8.161-11.13a.918.918 0 0 0-.927.928v8.161c0 .52.408.928.927.928h8.161c.52 0 .928-.408.928-.928v-8.16a.918.918 0 0 0-.928-.928h-8.161z'
          />
          <path
            fill='#0093E5'
            d='M87.281 34.685h-8.16a2.033 2.033 0 0 1-2.041-2.04v-8.162c0-1.131.909-2.04 2.04-2.04h8.161c1.132 0 2.04.909 2.04 2.04v8.161c0 1.132-.908 2.04-2.04 2.04zm-8.16-11.13a.918.918 0 0 0-.928.928v8.161c0 .52.408.928.927.928h8.161c.52 0 .928-.408.928-.928v-8.16a.918.918 0 0 0-.928-.928h-8.16z'
          />
          <path
            fill='#FFAE00'
            d='M70.792 23.964l-.52-.89.817-.483-2.152-3.635-.816.482-.52-.89 2.987-1.763c.742-.445 1.428-.593 2.059-.482.63.112 1.113.464 1.465 1.057l.89 1.503c.353.593.427 1.187.204 1.78-.204.594-.686 1.113-1.428 1.559l-2.986 1.762zm1.447-2.06l.927-.537c.482-.278.76-.575.853-.872.093-.297.019-.649-.222-1.057l-.78-1.317c-.24-.408-.519-.65-.834-.705-.315-.074-.705.037-1.187.315l-.927.538 2.17 3.636z'
          />
          <path
            fill='#FFAE00'
            d='M70.44 27.302a2.036 2.036 0 0 1-1.763-1.001l-4.154-7.03a2.037 2.037 0 0 1-.223-1.54c.132-.526.474-.975.946-1.242l7.03-4.155c.964-.575 2.226-.241 2.8.723l4.155 7.03c.279.464.353 1.02.223 1.54a1.985 1.985 0 0 1-.946 1.242l-7.048 4.137a1.862 1.862 0 0 1-1.02.296zm2.875-14.152a.837.837 0 0 0-.464.13l-7.03 4.155a.956.956 0 0 0-.427.575c-.055.24-.018.482.093.705l4.155 7.03a.92.92 0 0 0 1.261.333l7.03-4.155a.956.956 0 0 0 .427-.575 1.035 1.035 0 0 0-.093-.704l-4.155-7.03a.92.92 0 0 0-.797-.464zM33.398 31.012l-.315-.983.89-.297-1.317-4.006-.89.297-.315-.983 5.713-1.874.667 2.022-1.224.408-.334-1.039-2.337.76.464 1.41 1.818-.593.315.983-1.818.593.538 1.614 2.337-.76-.334-1.039 1.225-.408.667 2.022-5.75 1.873z'
          />
          <path
            fill='#FFAE00'
            d='M32.675 34.277a2.059 2.059 0 0 1-1.948-1.41l-2.54-7.753a2.022 2.022 0 0 1 1.298-2.579l7.753-2.54a2.05 2.05 0 0 1 2.578 1.298l2.541 7.753a2.022 2.022 0 0 1-1.298 2.578l-7.753 2.541a1.884 1.884 0 0 1-.631.112zm5.212-13.262c-.093 0-.185.018-.297.037l-7.753 2.54a.927.927 0 0 0-.593 1.17l2.54 7.753a.927.927 0 0 0 1.17.593l7.752-2.541a.927.927 0 0 0 .594-1.169l-2.523-7.753a.935.935 0 0 0-.89-.63z'
          />
          <path
            fill='#FF3D4B'
            d='M59.477 31.717v-1.039h1.577v-4.21h-1.577v-1.039h4.49v1.039H62.39v4.229h1.576v1.038h-4.489z'
          />
        </g>
      </g>
    </SvgIcon>
  )
}
